import {useScrollLock} from '@vueuse/core';

/** Matches `z-popup` / `--z-index-popup` in the generated Tailwind theme */
const MODAL_Z_INDEX_BASE = 100;

let nextId = 0;
const stack = ref<number[]>([]);

const body = ref<HTMLElement | null>(null);
let scrollLock: ReturnType<typeof useScrollLock> | null = null;

function initScrollLock() {
	if (!import.meta.client || scrollLock) {
		return;
	}

	body.value = document.body;
	scrollLock = useScrollLock(body);
}

function syncScrollLock() {
	if (!import.meta.client || !scrollLock) {
		return;
	}

	const locked = stack.value.length > 0;

	scrollLock.value = locked;
	document.documentElement.style.overflow = locked ? 'hidden' : '';
}

export function useModalStackEntry() {
	initScrollLock();

	const id = nextId++;

	const stackIndex = computed(() => stack.value.indexOf(id));
	const isFrontModal = computed(() => stack.value.at(-1) === id);
	const zIndex = computed(() => MODAL_Z_INDEX_BASE + Math.max(0, stackIndex.value));

	function register() {
		if (!import.meta.client || stack.value.includes(id)) {
			return;
		}

		stack.value = [...stack.value, id];
		syncScrollLock();
	}

	function unregister() {
		if (!import.meta.client || !stack.value.includes(id)) {
			return;
		}

		stack.value = stack.value.filter((entryId) => entryId !== id);
		syncScrollLock();
	}

	return {
		isFrontModal,
		zIndex,
		register,
		unregister,
	};
}
